module.exports = __webpack_public_path__ + "static/media/Medal_gold.39c0dfe8.png";